import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import sanitizeHtml from "sanitize-html";

import { setDeliveryLocation, setActiveCheckoutSection } from "../../../store/actions/checkout";

// Components
import LocationMap from "../../utils/maps/LocationMap";
import Modal from "../../modal/Modal";
import CloseButton from "../../modal/CloseButton";
import Loader from "../../utils/Loader";

// Util
import { setCheckoutSectionActive as setCheckoutSectionActiveGA, setCheckoutSectionComplete as setCheckoutSectionCompleteGA } from "../../../utils/google-analytics";

class StoreLocation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			saving: false,
			showModal: false
		};
	}

	closeAction() {
		this.setState({
			showModal: false
		});
	}

	selectStore = location => {
		this.props.setDeliveryLocation(location).then(() => {
			// Set current section as complete
			setCheckoutSectionCompleteGA(2);

			// Skip Shipping
			setCheckoutSectionActiveGA(3);
			setCheckoutSectionCompleteGA(3);

			// Set Billing active
			setCheckoutSectionActiveGA(4);
			this.props.setActiveCheckoutSection("billing");
		});
	};

	render() {
		const { location } = this.props;

		return (
			<div className="store-location">
				<div className="store-row">
					<div className="store-col">
						<div className="store-title">{location.title}</div>
					</div>
					<div className="store-col">
						{location.address}
						{location.formatted_location && <div>{location.formatted_location}</div>}
					</div>
					<div className="store-col">
						<button
							className={"btn select-store" + (this.state.saving ? " loading" : "")}
							disabled={this.props.saving}
							onClick={() => {
								this.setState(
									{
										saving: true
									},
									() => {
										this.selectStore(location);
									}
								);
							}}
						>
							<span>
								Pick up at this store<span className="icon icon-checkmark" />
							</span>
						</button>
					</div>
				</div>
				<div className="store-row">
					<div className="store-col">
						<div className="ajax-message" data-hbs-id="postal-{id}" />
						<input type="hidden" id={`postal-${location.id}`} value={location.postal} />
						<div className="see-map" onClick={() => this.setState({ showModal: true })}>
							<span className="icon-location" />See on map
						</div>
					</div>
					<div className="store-col" dangerouslySetInnerHTML={{ __html: sanitizeHtml(location.description) }} />
					<div className="store-col" />
				</div>
				{location.phone && (
					<div className="store-row">
						<div className="store-col" />
						<div className="store-col">{location.phone}</div>
						<div className="store-col" />
					</div>
				)}

				{this.state.showModal && (
					<Modal title={"Store Map"} buttons={[{ type: CloseButton, action: this.closeAction.bind(this) }]}>
						<LocationMap address={location.address} loadingElement={<Loader />} googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyA2mfXsrW3E8ZKx7pxKPFBRy-qE-wAEgOg&libraries=places" />
					</Modal>
				)}
			</div>
		);
	}
}

StoreLocation.propTypes = {
	location: PropTypes.shape({
		id: PropTypes.number.isRequired
	}).isRequired
};

export default connect(null, { setDeliveryLocation, setActiveCheckoutSection })(StoreLocation);



// WEBPACK FOOTER //
// ./src/components/checkout/delivery/StoreLocation.js